export default __webpack_public_path__ + "static/media/trailer-update.5abfe65b.png";